/* eslint-disable @typescript-eslint/no-explicit-any */
import Script from 'next/script';

declare global {
  interface Window {
    _ubaq: any;
  }
}

const UnbounceScript = (): JSX.Element => (
  <Script
    id="unbounce"
    onLoad={(): void => {
      const _ubaq = window._ubaq || [];
      _ubaq.push(['trackGoal', 'convert']);

      const initUnbounce = () => {
        const ub_script = document.createElement('script');
        ub_script.type = 'text/javascript';
        ub_script.src =
          ('https:' == document.location.protocol ? 'https://' : 'http://') +
          'd3pkntwtp2ukl5.cloudfront.net/uba.js';
        const s = document.getElementsByTagName('script')[0];
        s.parentNode?.insertBefore(ub_script, s);
      };

      initUnbounce();
    }}
  />
);

export default UnbounceScript;
